module.exports = __webpack_public_path__ + "files/SPIADI2023 - Présentation SRLF.52d512beafbc1f456115e17c08f734ef.pdf";